import { gql } from '@apollo/client'
import { FEATURE_CODES } from '@jusbrasil-web/docview/core'

import { ConvertDocumentButtonBase } from '../../convert-document-button-base'
import {
  ConvertModelButton_DocumentFragment,
  ConvertModelButton_ViewerFragment,
} from './__generated__/convert-model-button.graphql'

export interface ConvertModelButtonProps {
  document: ConvertModelButton_DocumentFragment
  viewer: ConvertModelButton_ViewerFragment | null
  onClick?: (successfulAttempt: boolean) => void
}

const boxProps = {
  featureCode: FEATURE_CODES.DOWNLOAD_MODELOS_CONTENT,
  fromComponent: 'docview/ConvertDocumentButton',
}

export function ConvertModelButton(props: ConvertModelButtonProps) {
  const { document, viewer, onClick } = props
  return (
    <ConvertDocumentButtonBase
      document={document}
      viewer={viewer}
      onClick={onClick}
      boxProps={boxProps}
      ga4EventLabel="ModelContent"
      viewerCanDownload={document.viewerCanDownload}
    />
  )
}

ConvertModelButton.fragments = {
  document: gql`
    fragment ConvertModelButton_document on Document {
      viewerCanDownload: viewerCanUseFeature(featureCode: "download_modelos_content")
      ...ConvertDocumentButtonBase_document
    }
    ${ConvertDocumentButtonBase.fragments.document}
  `,
  viewer: gql`
    fragment ConvertModelButton_viewer on Profile {
      ...ConvertDocumentButtonBase_viewer
    }
    ${ConvertDocumentButtonBase.fragments.viewer}
  `,
}
